import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { isStrictValidPhone } from "utils/fieldValidators";
import type { ChangeEvent } from "react";
import type { PhoneNumber } from "libphonenumber-js";

type ContactDialogInputPhoneNumberProps = {
  label: string;
  value: string;
  loading: boolean;
  disabled: boolean;
  numSelected?: number;
  phoneNumber: PhoneNumber | null;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function ContactDialogInputPhoneNumber({
  label,
  value,
  loading,
  disabled,
  numSelected,
  onChange
}: ContactDialogInputPhoneNumberProps): JSX.Element {
  const { t: translate } = useTranslation();

  // Strict: exact length + allocated prefix (or the exact IL mobile shape).
  // The lenient isPossible() parse let 9- and 11-digit "mobiles" through.
  const validPhoneNumber = value ? isStrictValidPhone(value) : true;

  const parsedValue = numSelected ? `${numSelected} ${translate("contactsPage.title")}` : value;

  return (
    <TextField
      required
      fullWidth
      InputLabelProps={{ shrink: value !== "" }}
      name="callerPhoneNumber"
      label={label}
      value={parsedValue}
      error={!validPhoneNumber}
      disabled={disabled || loading}
      helperText={!validPhoneNumber ? translate("contactsPage.error.invalidPhoneNumber") : ""}
      InputProps={{ readOnly: disabled }}
      onChange={onChange}
    />
  );
}
